import clsx from 'clsx'
import { useLayout } from '../../core'
import { KTIcon } from '../../../helpers/components/KTIcon'
import { toAbsoluteUrl } from '../../../helpers/AssetHelpers'
import { HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher } from '../../../partials'
import Box from '../../../../components/Box'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { Helpers } from '../../../../helpers/Helpers'
import BildirimZili from '../../../../components/BildirimZili'
import EntegrasyonHataIkonu from '../../../../components/EntegrasyonHataIkonu'
import { InvoiceService } from '../../../../services/InvoiceService'
import { AmbarService } from '../../../../services/AmbarService'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
    'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

const Navbar = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const { config } = useLayout()
    return (
        <div className='app-navbar flex-shrink-0'>


            <div className={clsx('app-navbar-item', itemClass)}>
                {/* Uyumsoft'ta hataya düşen e-irsaliye / e-fatura sayısı (07.10.2026); sayı 0 ise görünmez. */}
                <EntegrasyonHataIkonu
                    resim='media/icons/e-irsaliye.png'
                    baslik='E-İrsaliye Durumu Hata Olan Siparişler'
                    menuAdi='Kargo Modülü > Nakliye > Siparişler'
                    sayiGetir={AmbarService.getIrsaliyeErrorCount}
                    hedef='/ambar/list'
                    filtreler={[{ column: 'irsaliyeStatusName', values: ['Hata'], valueLabels: ['Hata'] }]}
                />
                <EntegrasyonHataIkonu
                    resim='media/icons/e-fatura.png'
                    baslik='E-Fatura Durumu Hata Olan Faturalar'
                    menuAdi='Ön Muhasebe > Fiş / Faturalar > Satış Faturaları'
                    sayiGetir={InvoiceService.getEfaturaErrorCount}
                    hedef='/saleinvoice/list'
                    filtreler={[{ column: 'efaturaStatusName', values: ['Hata'], valueLabels: ['Hata'] }]}
                />
                <BildirimZili />

                <Box mr='30px' flexDirection='row'>
                    <Box mr='10px' justifyContent='center'>
                        <span style={{ fontSize: 24, fontWeight: 400 }} className='text-success'>USD</span>
                    </Box>
                    <Box justifyContent='center'>
                        <Box>
                            <span className='text-black' style={{ fontWeight: 400, margin: 0, padding: 0, lineHeight: 1, fontSize: 13 }}>A - {auth.currencyConversionList.find(x => x.toCurrencyName == "USD")?.buyStr}</span>
                        </Box>
                        <Box mt='3px'>
                            <span className='text-black' style={{ fontWeight: 400, margin: 0, padding: 0, lineHeight: 1, fontSize: 13 }}>S - {auth.currencyConversionList.find(x => x.toCurrencyName == "USD")?.sellStr}</span>
                        </Box>
                    </Box>

                    <Box ml='30px' mr='10px' justifyContent='center'>
                        <span style={{ fontSize: 24, fontWeight: 400 }} className='text-primary'>EUR</span>
                    </Box>
                    <Box justifyContent='center'>
                        <Box>
                            <span className='text-black' style={{ fontWeight: 400, margin: 0, padding: 0, lineHeight: 1, fontSize: 13 }}>A - {auth.currencyConversionList.find(x => x.toCurrencyName == "EUR")?.buyStr}</span>
                        </Box>
                        <Box mt='3px'>
                            <span className='text-black' style={{ fontWeight: 400, margin: 0, padding: 0, lineHeight: 1, fontSize: 13 }}>S - {auth.currencyConversionList.find(x => x.toCurrencyName == "EUR")?.sellStr}</span>
                        </Box>
                    </Box>
                </Box>

                <div
                    className={clsx('cursor-pointer symbol', userAvatarClass)}
                    data-kt-menu-trigger="{default: 'click'}"
                    data-kt-menu-attach='parent'
                    data-kt-menu-placement='bottom-end'
                >
                    <img src={Helpers.getPlaceholder()} alt='' />
                </div>
                <HeaderUserMenu />
            </div>

            {config.app?.header?.default?.menu?.display && (
                <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
                    <div
                        className='btn btn-icon btn-active-color-primary w-35px h-35px'
                        id='kt_app_header_menu_toggle'
                    >
                        <KTIcon iconName='text-align-left' className={btnIconClass} />
                    </div>
                </div>
            )}
        </div>
    )
}

export { Navbar }
